'use client';

import {styled, Box, keyframes} from '@mui/material';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const MarqueeWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.tv4Red.red04,
  padding: theme.spacing(2, 0),
  margin: theme.spacing(8, 0, 8, 0),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(6, 0, 6, 0),
  },
  '&:hover > *': {
    animationPlayState: 'paused',
  },
}));

export const MarqueeTrack = styled(Box)({
  display: 'flex',
  width: 'fit-content',
  animation: `${scroll} 60s linear infinite`,
});

export const MarqueeItemWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexShrink: 0,
  padding: theme.spacing(0, 1),
}));

export const MainImageBox = styled(Box)(({theme}) => ({
  flexShrink: 0,
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusMd,
  '& img': {
    display: 'block',
    width: 320,
    height: 391,
    objectFit: 'cover',
  },
  [theme.breakpoints.down('sm')]: {
    '& img': {
      display: 'block',
      width: 200,
      height: 280,
      objectFit: 'cover',
    },
  },
}));

export const ContentCard = styled(Box)(({theme}) => ({
  position: 'relative',
  overflow: 'hidden',
  flexShrink: 0,
  width: 320,
  height: 391,
  [theme.breakpoints.down('sm')]: {
    width: 200,
    height: 280,
  },
  borderRadius: theme.shape.borderRadiusMd,
}));

export const ContentCardOverlay = styled(Box)(({theme}) => ({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  height: '100%',
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));
